module.exports = "<div class=\"container my-2 d-print-none\">\n    <app-fits-table ></app-fits-table>\n</div>\n"